var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"chcek","d":"M163.9,205 186,227.2 238.1,175.1"}));
}

Check.defaultProps = {"version":"1.1","baseProfile":"basic","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 398.1 398.1","xmlSpace":"preserve"};

module.exports = Check;

Check.default = Check;
